/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import { IFeaturedListTwoData } from './featured-list-two.data';
import { IFeaturedListTwoProps } from './featured-list-two.props.autogenerated';

export interface IFeaturedListTwoViewProps
  extends IFeaturedListTwoProps<IFeaturedListTwoData> {
  featuredList2?: React.ReactNode;
}

/**
 *
 * FeaturedListTwo component
 * @extends {React.PureComponent<IFeaturedListTwoProps<IFeaturedListTwoData>>}
 */
class FeaturedListTwo extends React.PureComponent<
  IFeaturedListTwoProps<IFeaturedListTwoData>
> {
  public render(): JSX.Element | null {
    const {
      listHeading,
      cssClassName,
      featuredProductImage1,
      productDescription1,
      productLink1,
      featuredProductImage2,
      productDescription2,
      productLink2,
      featuredProductImage3,
      productDescription3,
      productLink3,
    } = this.props.config;

    const imageProps1 = {
      gridSettings: this.props.context.request.gridSettings || {},
      imageSettings:
        featuredProductImage1 && featuredProductImage1.imageSettings,
    };
    const featuredDynamicProductImage1 = featuredProductImage1 && (
      <Msdyn365.Image
        className={cssClassName}
        altText={productDescription1}
        {...featuredProductImage1}
        {...imageProps1}
        editProps={{
          key: this.props.config.featuredProductImage1 || {},
          requestContext: this.props.context.request,
        }}
      />
    );

    const featuredDynamicProduct1 = (
      <div className='col-lg-4 col-md-4 col-sm-12 col-xs-12 product-box'>
        <div className='row product-row'>
          <div className='promo-product col-lg-12 col-md-12 col-sm-6 col-xs-6'>
            <a href={productLink1} className='img-link'>
              {featuredDynamicProductImage1}
            </a>
          </div>
          <div className='product-info col-lg-12 col-md-12 col-sm-6 col-xs-6'>
            <a href={productLink1} className='product-link'>
              {productDescription1}
            </a>
          </div>
        </div>
      </div>
    );
    const imageProps2 = {
      gridSettings: this.props.context.request.gridSettings || {},
      imageSettings:
        featuredProductImage2 && featuredProductImage2.imageSettings,
    };
    const featuredDynamicProductImage2 = featuredProductImage2 && (
      <Msdyn365.Image
        className={cssClassName}
        altText={productDescription2}
        {...featuredProductImage2}
        {...imageProps2}
        editProps={{
          key: this.props.config.featuredProductImage2 || {},
          requestContext: this.props.context.request,
        }}
      />
    );

    const featuredDynamicProduct2 = (
      <div className='col-lg-4 col-md-4 col-sm-12 col-xs-12 product-box'>
        <div className='row product-row'>
          <div className='promo-product col-lg-12 col-md-12 col-sm-6 col-xs-6'>
            <a href={productLink2} className='img-link'>
              {featuredDynamicProductImage2}
            </a>
          </div>
          <div className='product-info col-lg-12 col-md-12 col-sm-6 col-xs-6'>
            <a href={productLink2} className='product-link'>
              {productDescription2}
            </a>
          </div>
        </div>
      </div>
    );
    const imageProps3 = {
      gridSettings: this.props.context.request.gridSettings || {},
      imageSettings:
        featuredProductImage3 && featuredProductImage3.imageSettings,
    };
    const featuredDynamicProductImage3 = featuredProductImage3 && (
      <Msdyn365.Image
        className={cssClassName}
        altText={productDescription3}
        {...featuredProductImage3}
        {...imageProps3}
        editProps={{
          key: this.props.config.featuredProductImage3 || {},
          requestContext: this.props.context.request,
        }}
      />
    );

    const featuredDynamicProduct3 = (
      <div className='col-lg-4 col-md-4 col-sm-12 col-xs-12 product-box'>
        <div className='row product-row'>
          <div className='promo-product col-lg-12 col-md-12 col-sm-6 col-xs-6'>
            <a href={productLink3} className='img-link'>
              {featuredDynamicProductImage3}
            </a>
          </div>
          <div className='product-info col-lg-12 col-md-12 col-sm-6 col-xs-6'>
            <a href={productLink3} className='product-link'>
              {productDescription3}
            </a>
          </div>
        </div>
      </div>
    );

    const featuredListTwo = (
      <div className='row feature-row'>
        <div className='col-md-12'>
          <h1 className={`feature-product-heading ${cssClassName}`}>
            {listHeading}
          </h1>
        </div>
        {featuredDynamicProduct1}
        {featuredDynamicProduct2}
        {featuredDynamicProduct3}
      </div>
    );
    const FeaturedListTwoProps = {
      ...this.props,
      featuredList2: featuredListTwo,
    };
    return this.props.renderView(FeaturedListTwoProps);
  }
}

export default FeaturedListTwo;
